/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';

/**
 * 
 * @export
 * @interface GetBlockadeMonthExceptionDto
 */
export interface GetBlockadeMonthExceptionDto {
    /**
     * 
     * @type {string}
     * @memberof GetBlockadeMonthExceptionDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetBlockadeMonthExceptionDto
     */
    date: Date;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetBlockadeMonthExceptionDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetBlockadeMonthExceptionDto
     */
    isSalesUnblocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBlockadeMonthExceptionDto
     */
    isPurchaseUnblocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetBlockadeMonthExceptionDto
     */
    active: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetBlockadeMonthExceptionDto
     */
    creator: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetBlockadeMonthExceptionDto
     */
    dateToDelete?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetBlockadeMonthExceptionDto
     */
    reason: string;
}

/**
 * Check if a given object implements the GetBlockadeMonthExceptionDto interface.
 */
export function instanceOfGetBlockadeMonthExceptionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "isSalesUnblocked" in value;
    isInstance = isInstance && "isPurchaseUnblocked" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "creator" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function GetBlockadeMonthExceptionDtoFromJSON(json: any): GetBlockadeMonthExceptionDto {
    return GetBlockadeMonthExceptionDtoFromJSONTyped(json, false);
}

export function GetBlockadeMonthExceptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBlockadeMonthExceptionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'project': GetProjectDtoFromJSON(json['project']),
        'isSalesUnblocked': json['isSalesUnblocked'],
        'isPurchaseUnblocked': json['isPurchaseUnblocked'],
        'active': json['active'],
        'creator': GetEmployeeDtoFromJSON(json['creator']),
        'dateToDelete': !exists(json, 'dateToDelete') ? undefined : (new Date(json['dateToDelete'])),
        'reason': json['reason'],
    };
}

export function GetBlockadeMonthExceptionDtoToJSON(value?: GetBlockadeMonthExceptionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'project': GetProjectDtoToJSON(value.project),
        'isSalesUnblocked': value.isSalesUnblocked,
        'isPurchaseUnblocked': value.isPurchaseUnblocked,
        'active': value.active,
        'creator': GetEmployeeDtoToJSON(value.creator),
        'dateToDelete': value.dateToDelete === undefined ? undefined : (value.dateToDelete.toISOString()),
        'reason': value.reason,
    };
}

